import ClientCard from "@components/ClientCard/ClientCard";
import Logout from "@components/Logout";
import ROUTES from "@constants/routing";
import { useKeycloakAdmin } from "@hooks";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import { useClients } from "@services/api";
import dayjs from "dayjs";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import ClientCardSkeleton from "./components/ClientCardSkeleton";

const ViewHome = () => {
  const hasKeycloakAdmin = useKeycloakAdmin();

  const navigate = useNavigate();

  const { data: clients, isFetching: isLoadingClients } = useClients();

  const clientCards = useMemo(() => {
    const clientCount = (clients || []).length;
    // Calculate grid size: max 4 per row, or evenly distribute if less than 4
    const gridSize =
      clientCount > 0 ? Math.min(12 / Math.min(clientCount, 4), 12) : 12;

    return (clients || [])
      .sort((a, b) =>
        dayjs(b.created_at, "yyyy-MM-dd").diff(
          dayjs(a.created_at, "yyyy-MM-dd")
        )
      )
      .map((client) => (
        <Grid size={{ xs: 6, sm: 6, md: gridSize }} key={client.id}>
          <ClientCard clientShort={client} alignItems="center" enabled={true} />
        </Grid>
      ));
  }, [clients]);

  const skeletonCards = useMemo(() => {
    return Array.from({ length: 1 }).map((_, index) => (
      <Grid size={{ xs: 12, md: 12, lg: 12 }} key={`skeleton-${index}`}>
        <ClientCardSkeleton />
      </Grid>
    ));
  }, []);

  const onAdminClick = () => {
    navigate(ROUTES.ADMIN_PANEL);
  };

  return (
    <Box className="w-screen md:h-screen relative flex flex-col items-center justify-center p-4">
      <Box className="md:absolute md:top-3 md:right-6 w-full flex justify-between">
        <Box className="justify-start">
          {hasKeycloakAdmin ? (
            <IconButton
              color="info"
              style={{ backgroundColor: "white", marginLeft: 36 }}
              onClick={onAdminClick}
            >
              <AdminPanelSettingsIcon />
            </IconButton>
          ) : null}
        </Box>
        <Box className="justify-end">
          <Logout />
        </Box>
      </Box>
      <Box className="flex justify-center xl:mt-16 mt-4">
        <Grid container spacing={2}>
          {isLoadingClients ? skeletonCards : clientCards}
        </Grid>
      </Box>
    </Box>
  );
};

export default ViewHome;
